import len from '../core/len.js';
/**
 * Same as {@link len}.
 */
const count = len;
export default count;
